<template>
  <div
    class="relative flex h-[50px] shrink-0 select-none items-center rounded-8 bg-bg-base-bg4"
    :class="isImage
      ? 'w-48 overflow-visible p-0 phone:size-[50px] phone:w-[50px]'
      : 'w-48 overflow-visible p-2'"
  >
    <div
      class="relative shrink-0 overflow-hidden"
      :class="isImage ? 'size-[50px] rounded-8' : 'size-[34px] rounded-8'"
    >
      <file-icon
        class="h-full w-full"
        :mime="file.filemime!"
        :cookie="file.filecookie"
        :name="file.filename"
        :open-preview-on-click="false"
        :object-fit="isImage ? 'cover' : 'contain'"
        :bordered="false"
      />
    </div>

    <div
      class="relative min-w-0 flex-1 truncate"
      :class="isImage ? 'px-2 phone:hidden' : 'pl-2'"
    >
      <p class="truncate text-body-m-14-20 text-fg-base-fg3">
        {{ fileNameWithoutExtension }}
      </p>
      <p
        v-if="fileMeta"
        class="truncate text-label-r-13-18 text-fg-base-fg17"
      >
        {{ fileMeta }}
      </p>
    </div>

    <button
      type="button"
      data-test="delete-file-from-editing-btn"
      class="
        absolute -right-1.5 -top-1.5 z-10 flex size-[22px] items-center justify-center
        rounded-[22px] bg-fg-base-fg3 text-white
      "
      @click.stop="emit('delete', file.filecookie)"
    >
      <wui-icon
        name="closeRegularSmM"
        class="size-3"
      />
      <span class="sr-only">{{ $t('common.removeFile') }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'
import { IMFile } from '@wui/im'
import { computed } from 'vue'

import { FileIcon } from '@/entities/chat-event-file'

import { bytesConverter } from '@/shared/utils/bytes-converter'
import { isImageFile } from '@/shared/utils/files'

const props = defineProps<{
  file: IMFile,
}>()

const emit = defineEmits<{
  (event: 'delete', filecookie: string): void;
}>()

const isImage = computed(() => isImageFile(props.file.filename))

const fileNameWithoutExtension = computed(() => {
  const fileNameAndExtension = props.file.filename.split('.')
  fileNameAndExtension.pop()
  return fileNameAndExtension.join('.')
})

const fileExtension = computed(() => {
  return props.file.filename.split('.').pop()?.toUpperCase() ?? ''
})

const fileMeta = computed(() => {
  if (props.file.filesize == null) return fileExtension.value
  return `${bytesConverter(props.file.filesize)}, ${fileExtension.value}`
})
</script>
